// Dynamically add has-js class immediately
var root = document.getElementsByTagName('html')[0];
root.classList.add('has-js');

// Dynamically set scrollbar width css variable
function getScrollbarWidth() {
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);
    var inner = document.createElement('div');
    outer.appendChild(inner);
    var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    return scrollbarWidth + 'px';
}

// Once body exists run functions
(function domBodyExists() {
    if (document.body) {

        // Set dynamic scrollbar width variable
        root.classList.add('js-scrollbar-width-set');
        document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth());

        // Update scrollbar width after resize
        window.addEventListener('resize', function () {
            document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth());
        });

        waitForElExistence('.site-header__alert-wrap').then((elm) => {

            // Top level alert
            const siteBody = document.querySelector('.l-body');
            const siteHeader = document.querySelector('.site-header');
            const siteAlertWrap = document.querySelector('.site-header__alert-wrap');
            const siteAlert = document.querySelectorAll('.site-header__alert-wrap .site-header__alert');
            let sitePeakChildHeight;
            let bodyElStyle;
            let cssVarHeaderHeight;
            let siteAlertCookie;
            let siteAlertCookieArr;
            let siteHeaderHeight;

            if (siteAlertWrap.hasChildNodes()) {

                // Alert cookie related
                if (siteAlert) {
                    siteAlertCookie = getCookie('siteAlertHidden');
                    siteAlertCookieArr = (siteAlertCookie !== null) ? siteAlertCookie.split(',') : null;

                    if (siteAlertCookieArr === null || siteAlertCookieArr.length !== siteAlert.length) {
                        root.classList.add('js-alert-visible');

                        if (siteAlertCookieArr !== null) {
                            siteAlertCookieArr.forEach(item => {
                                document.getElementById(item).remove();
                            });
                        }

                    }
                    else {
                        siteAlertWrap.remove();
                    }

                    // Remove alert on close button
                    siteAlert.forEach(alert => {
                        alert.addEventListener('hidden.bs.collapse', () => {
                            const alertAmount = document.querySelectorAll('.site-header__alert-wrap .site-header__alert');

                            let alertCSV = (getCookie('siteAlertHidden') !== null) ? getCookie('siteAlertHidden') + ',' + alert.id : alert.id;
                            setCookie(`siteAlertHidden`, alertCSV, 2);
                        });
                    });
                }
            }
        })
    } else {
        window.requestAnimationFrame(domBodyExists);
    }
})();

// Global cookie handling
function setCookie(name, value, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
}

function waitForElExistence(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
